import React, { useState, useEffect } from 'react';
import { getEventsAdmin, createEvent, deleteEvent, createInvitations, togglePublishEvent, getSeriesAdmin, getGenres, createGenre } from '../services/api';
import Navbar from '../components/Navbar';
import ImageCropper from '../components/ImageCropper';
import useWindowSize from '../hooks/useWindowSize';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { useTheme } from '../context/ThemeContext';

function Admin() {
  const [events, setEvents] = useState([]);
  const [seriesList, setSeriesList] = useState([]);
  const [genresList, setGenresList] = useState([]);
  const [newGenre, setNewGenre] = useState('');
  const [addingGenre, setAddingGenre] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null, name: '' });
  const [invModal, setInvModal] = useState({ show: false, event: null });
  const [invForm, setInvForm] = useState({ email: '', quantity: 10 });
  const [invLoading, setInvLoading] = useState(false);
  const [invSuccess, setInvSuccess] = useState('');
  const [invError, setInvError] = useState('');
  const [form, setForm] = useState({
    name: '', date: '', location: '', price: '',
    total_tickets: '', category: 'Música', image: null, banner_image: null,
    description: '', map_url: '', seat_info: '', series_id: '', genre: '',
    video1: '', video2: '', video3: '', video4: '', video5: '', video6: '',
  });
  const [preview, setPreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const styles = {
    container: { minHeight: '100vh', backgroundColor: colors.bg },
    content: { padding: isMobile ? '1rem' : '2rem' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', marginBottom: isMobile ? '1rem' : '2rem', flexDirection: isMobile ? 'column' : 'row', gap: '0.8rem' },
    title: { color: colors.text, fontSize: isMobile ? '1.4rem' : '2rem', fontWeight: 'bold' },
    addBtn: { display: 'flex', alignItems: 'center', gap: '0.5rem', backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: isMobile ? '0.5rem 1rem' : '0.6rem 1.5rem', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : '0.95rem', whiteSpace: 'nowrap', alignSelf: isMobile ? 'flex-start' : 'auto' },
    modalOverlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' },
    modal: { backgroundColor: colors.bgSecondary, border: '1px solid #ff444444', borderRadius: '16px', padding: isMobile ? '1.5rem' : '2.5rem', maxWidth: '450px', width: '100%', textAlign: 'center' },
    invModal: { backgroundColor: colors.bgSecondary, border: `1px solid ${colors.border}`, borderRadius: '16px', padding: isMobile ? '1.5rem' : '2rem', maxWidth: '480px', width: '100%' },
    modalTitle: { color: colors.text, fontSize: isMobile ? '1.2rem' : '1.5rem', fontWeight: 'bold', marginBottom: '1rem' },
    modalText: { color: colors.textSecondary, fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '2rem' },
    modalButtons: { display: 'flex', gap: '1rem', justifyContent: 'center' },
    deleteConfirmBtn: { backgroundColor: '#ff4444', color: '#ffffff', border: 'none', padding: '0.7rem 2rem', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.95rem' },
    form: { backgroundColor: colors.bgSecondary, border: `1px solid ${colors.border}`, borderRadius: '12px', padding: isMobile ? '1rem' : '2rem', marginBottom: '2rem' },
    formTitle: { color: colors.accent, fontSize: isMobile ? '1.1rem' : '1.3rem', fontWeight: 'bold', marginBottom: '1.5rem' },
    formGrid: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem', marginBottom: '1rem' },
    formGroup: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
    label: { color: colors.textSecondary, fontSize: '0.85rem' },
    input: { backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.6rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none' },
    feePreview: { color: colors.textSecondary, fontSize: '0.8rem', marginTop: '0.2rem' },
    sectionDivider: { borderTop: `1px solid ${colors.border}`, paddingTop: '1.2rem', marginTop: '1.2rem', marginBottom: '1rem' },
    sectionLabel: { color: colors.text, fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '0.8rem' },
    videosGrid: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: '0.8rem' },
    formButtons: { display: 'flex', gap: '1rem', marginTop: '1.5rem', justifyContent: isMobile ? 'stretch' : 'flex-end', flexDirection: isMobile ? 'column' : 'row' },
    cancelBtn: { backgroundColor: 'transparent', border: `1px solid ${colors.border}`, color: colors.textSecondary, padding: '0.6rem 1.5rem', borderRadius: '20px', cursor: 'pointer', fontSize: '0.95rem' },
    submitBtn: { backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.6rem 1.5rem', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.95rem' },
    sectionTitle: { color: colors.text, fontSize: isMobile ? '1.1rem' : '1.3rem', fontWeight: 'bold', marginBottom: '1rem' },
    text: { color: colors.textSecondary },
    table: { backgroundColor: colors.bgSecondary, borderRadius: '12px', border: `1px solid ${colors.border}`, overflow: 'hidden' },
    tableHeader: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr', padding: '1rem 1.5rem', backgroundColor: colors.bgTertiary, color: colors.accent, fontSize: '0.85rem', fontWeight: 'bold' },
    tableRow: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr', padding: '1rem 1.5rem', borderTop: `1px solid ${colors.border}`, alignItems: 'center' },
    eventName: { color: colors.text, fontSize: '0.95rem', fontWeight: '500' },
    cell: { color: colors.textSecondary, fontSize: '0.9rem' },
    cellAccent: { color: colors.accent, fontSize: '0.9rem', fontWeight: 'bold' },
    cellFee: { color: '#ffaa00', fontSize: '0.9rem', fontWeight: 'bold' },
    cellTag: { color: colors.accentText, backgroundColor: colors.accent, padding: '0.2rem 0.6rem', borderRadius: '10px', fontSize: '0.8rem', fontWeight: 'bold', display: 'inline-block' },
    deleteBtn: { backgroundColor: 'transparent', border: '1px solid #ff444444', color: '#ff4444', borderRadius: '8px', padding: '0.3rem 0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    invBtn: { backgroundColor: 'transparent', border: `1px solid ${colors.border}`, color: colors.accent, borderRadius: '8px', padding: '0.3rem 0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    publishBtn: (published) => ({ backgroundColor: 'transparent', border: `1px solid ${published ? '#00cc66' : colors.border}`, color: published ? '#00cc66' : colors.textSecondary, borderRadius: '8px', padding: '0.3rem 0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }),
  };

  const calcFee = (price) => {
    if (!price) return '0.00';
    return (parseFloat(price) * 0.10).toFixed(2);
  };

  const loadEvents = () => {
    getEventsAdmin()
      .then(res => { setEvents(res.data); setLoading(false); })
      .catch(() => setLoading(false));
  };

  const loadSeries = () => {
    getSeriesAdmin()
      .then(res => setSeriesList(res.data))
      .catch(() => setSeriesList([]));
  };

  const loadGenres = () => {
    getGenres()
      .then(res => setGenresList(res.data))
      .catch(() => setGenresList([]));
  };

  useEffect(() => { loadEvents(); loadSeries(); loadGenres(); }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleAddGenre = async () => {
    if (!newGenre.trim()) return;
    setAddingGenre(true);
    try {
      const res = await createGenre({ name: newGenre.trim() });
      await loadGenres();
      setForm(f => ({ ...f, genre: res.data.name }));
      setNewGenre('');
    } catch (err) {
      alert('Error al añadir la categoría');
    }
    setAddingGenre(false);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const data = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v) data.append(k, v); });
      await createEvent(data);
      setShowForm(false);
      setForm({
        name: '', date: '', location: '', price: '', total_tickets: '',
        category: 'Música', image: null, banner_image: null,
        description: '', map_url: '', seat_info: '', series_id: '', genre: '',
        video1: '', video2: '', video3: '', video4: '', video5: '', video6: '',
      });
      setPreview(null);
      setBannerPreview(null);
      loadEvents();
    } catch (err) {
      alert('Error al crear el evento');
    }
    setSubmitting(false);
  };

  const confirmDelete = async () => {
    try {
      await deleteEvent(deleteModal.id);
      setDeleteModal({ show: false, id: null, name: '' });
      loadEvents();
    } catch (err) {
      alert('Error al eliminar el evento');
    }
  };

  const handleTogglePublish = async (event) => {
    try {
      await togglePublishEvent(event.id);
      loadEvents();
    } catch (err) {
      alert('Error al cambiar el estado del evento');
    }
  };

  const handleInvitation = async () => {
    setInvError('');
    setInvSuccess('');
    if (!invForm.email.trim()) return setInvError('Introduce un email');
    if (!invForm.quantity || invForm.quantity < 1) return setInvError('Introduce una cantidad válida');
    setInvLoading(true);
    try {
      await createInvitations({
        event_id: invModal.event.id,
        quantity: parseInt(invForm.quantity),
        email: invForm.email.trim(),
      });
      setInvSuccess(`✅ ${invForm.quantity} invitaciones enviadas a ${invForm.email}`);
      loadEvents();
    } catch (err) {
      setInvError(err.response?.data?.error || 'Error al generar invitaciones');
    }
    setInvLoading(false);
  };

  return (
    <div style={styles.container}>
      <Navbar />

      {deleteModal.show && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <WarningAmberIcon style={{ color: '#ff4444', fontSize: '3rem', marginBottom: '1rem' }} />
            <h2 style={styles.modalTitle}>Eliminar evento?</h2>
            <p style={styles.modalText}>
              Estas a punto de eliminar <strong style={{ color: colors.text }}>{deleteModal.name}</strong>. Esta accion no se puede deshacer.
            </p>
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setDeleteModal({ show: false, id: null, name: '' })}>Cancelar</button>
              <button style={styles.deleteConfirmBtn} onClick={confirmDelete}>Si, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {invModal.show && (
        <div style={styles.modalOverlay}>
          <div style={styles.invModal}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.2rem' }}>
              <ConfirmationNumberIcon style={{ color: colors.accent, fontSize: 28 }} />
              <div>
                <h2 style={{ color: colors.text, fontSize: '1.2rem', fontWeight: 'bold', margin: 0 }}>Generar invitaciones</h2>
                <p style={{ color: colors.textSecondary, fontSize: '0.82rem', margin: 0 }}>{invModal.event?.name}</p>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.2rem' }}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Email destino</label>
                <input style={styles.input} type="email" placeholder="email@ejemplo.com" value={invForm.email} onChange={e => setInvForm(f => ({ ...f, email: e.target.value }))} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Cantidad de invitaciones</label>
                <input style={styles.input} type="number" min="1" max={invModal.event?.available_tickets} value={invForm.quantity} onChange={e => setInvForm(f => ({ ...f, quantity: e.target.value }))} />
                <span style={{ color: colors.textSecondary, fontSize: '0.75rem' }}>Máximo disponible: {invModal.event?.available_tickets}</span>
              </div>
            </div>
            {invError && <div style={{ backgroundColor: '#ff444422', border: '1px solid #ff4444', color: '#ff4444', padding: '0.7rem 1rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.85rem' }}>{invError}</div>}
            {invSuccess && <div style={{ backgroundColor: '#d4edda', border: '1px solid #28a745', color: '#155724', padding: '0.7rem 1rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.85rem' }}>{invSuccess}</div>}
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button style={styles.cancelBtn} onClick={() => { setInvModal({ show: false, event: null }); setInvForm({ email: '', quantity: 10 }); setInvSuccess(''); setInvError(''); }}>
                {invSuccess ? 'Cerrar' : 'Cancelar'}
              </button>
              {!invSuccess && (
                <button style={{ ...styles.submitBtn, backgroundColor: '#28a745' }} onClick={handleInvitation} disabled={invLoading}>
                  {invLoading ? 'Enviando...' : 'Generar y enviar'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <div style={styles.content}>
        <div style={styles.header}>
          <h1 style={styles.title}>Panel de administrador</h1>
          <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
            <AddIcon /> Nuevo evento
          </button>
        </div>

        {showForm && (
          <div style={styles.form}>
            <h2 style={styles.formTitle}>Crear nuevo evento</h2>
            <div style={styles.formGrid}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Nombre del evento</label>
                <input style={styles.input} name="name" value={form.name} onChange={handleChange} placeholder="Nombre del evento" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Fecha y hora</label>
                <input style={styles.input} name="date" type="datetime-local" value={form.date} onChange={handleChange} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Ubicacion</label>
                <input style={styles.input} name="location" value={form.location} onChange={handleChange} placeholder="Ciudad, Recinto" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Precio (€)</label>
                <input style={styles.input} name="price" type="number" value={form.price} onChange={handleChange} placeholder="0.00" />
                {form.price && (
                  <span style={styles.feePreview}>
                    Gasto de gestion: <strong style={{ color: colors.accent }}>{calcFee(form.price)}€</strong>
                    &nbsp;— El comprador pagara <strong style={{ color: colors.accent }}>{(parseFloat(form.price) + parseFloat(calcFee(form.price))).toFixed(2)}€</strong>
                  </span>
                )}
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Total de entradas</label>
                <input style={styles.input} name="total_tickets" type="number" value={form.total_tickets} onChange={handleChange} placeholder="100" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Categoria</label>
                <select style={styles.input} name="category" value={form.category} onChange={handleChange}>
                  {['Música', 'Deportes', 'Teatro', 'Festivales', 'Otros'].map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Serie / Colección <span style={{ opacity: 0.6, fontSize: '0.75rem' }}>(opcional)</span></label>
                <select style={styles.input} name="series_id" value={form.series_id} onChange={handleChange}>
                  <option value="">Ninguna (evento individual)</option>
                  {seriesList.map(s => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Categoría interna (marketing) <span style={{ opacity: 0.6, fontSize: '0.75rem' }}>(opcional)</span></label>
                <select style={styles.input} name="genre" value={form.genre} onChange={handleChange}>
                  <option value="">Ninguna</option>
                  {genresList.map(g => (
                    <option key={g.id} value={g.name}>{g.name}</option>
                  ))}
                </select>
                <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.4rem' }}>
                  <input
                    style={{ ...styles.input, padding: '0.4rem 0.8rem', fontSize: '0.85rem' }}
                    value={newGenre}
                    onChange={e => setNewGenre(e.target.value)}
                    placeholder="Ej: Reggaeton"
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleAddGenre(); } }}
                  />
                  <button
                    type="button"
                    onClick={handleAddGenre}
                    disabled={addingGenre || !newGenre.trim()}
                    style={{ backgroundColor: colors.bgTertiary, border: `1px solid ${colors.border}`, color: colors.accent, borderRadius: '8px', padding: '0.4rem 1rem', cursor: addingGenre ? 'default' : 'pointer', fontSize: '0.85rem', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                  >
                    {addingGenre ? 'Añadiendo...' : '+ Añadir'}
                  </button>
                </div>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Enlace Google Maps <span style={{ opacity: 0.6, fontSize: '0.75rem' }}>(opcional)</span></label>
                <input style={styles.input} name="map_url" value={form.map_url} onChange={handleChange} placeholder="https://maps.google.com/..." />
              </div>
            </div>
            <div style={{ ...styles.formGroup, marginBottom: '1.2rem' }}>
              <label style={styles.label}>Aviso tipo de entrada <span style={{ opacity: 0.6, fontSize: '0.75rem' }}>(opcional)</span></label>
              <input style={styles.input} name="seat_info" value={form.seat_info} onChange={handleChange} placeholder="Ej: Entrada de asiento no numerado." />
            </div>
            <div style={{ ...styles.formGroup, marginBottom: '1.2rem' }}>
              <label style={styles.label}>Descripción del evento <span style={{ opacity: 0.6, fontSize: '0.75rem' }}>(opcional)</span></label>
              <textarea style={{ ...styles.input, minHeight: '90px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }} name="description" value={form.description} onChange={handleChange} placeholder="Describe el evento..." />
            </div>
            <div style={{ marginBottom: '1.2rem' }}>
              <ImageCropper label="Cartel del evento — vertical" hint="(proporcion 2:3 — aparece en la pagina del evento)" aspect={2 / 3} colors={colors} preview={preview} onDone={(file, previewUrl) => { setForm(f => ({ ...f, image: file })); setPreview(previewUrl); }} />
            </div>
            <div style={{ marginBottom: '1.2rem' }}>
              <ImageCropper label="Banner del hero — horizontal" hint="(1980x1080px — aparece en la portada)" aspect={1980 / 1080} colors={colors} preview={bannerPreview} onDone={(file, previewUrl) => { setForm(f => ({ ...f, banner_image: file })); setBannerPreview(previewUrl); }} />
            </div>
            <div style={styles.sectionDivider}>
              <p style={styles.sectionLabel}>Videos de YouTube <span style={{ color: colors.textSecondary, fontSize: '0.75rem', fontWeight: 'normal' }}>(opcional)</span></p>
              <div style={styles.videosGrid}>
                {[1, 2, 3, 4, 5, 6].map(n => (
                  <div key={n} style={styles.formGroup}>
                    <label style={styles.label}>Video {n}</label>
                    <input style={styles.input} name={`video${n}`} value={form[`video${n}`]} onChange={handleChange} placeholder="https://www.youtube.com/watch?v=..." />
                  </div>
                ))}
              </div>
            </div>
            <div style={styles.formButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowForm(false)}>Cancelar</button>
              <button style={styles.submitBtn} onClick={handleSubmit} disabled={submitting}>
                {submitting ? 'Creando...' : 'Crear evento'}
              </button>
            </div>
          </div>
        )}

        <h2 style={styles.sectionTitle}>Eventos ({events.length})</h2>
        {loading ? (
          <p style={styles.text}>Cargando...</p>
        ) : events.length === 0 ? (
          <p style={styles.text}>No hay eventos</p>
        ) : isMobile ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            {events.map(event => (
              <div key={event.id} style={{ backgroundColor: colors.bgSecondary, borderRadius: '12px', border: `1px solid ${event.published ? '#00cc6633' : colors.border}`, padding: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.6rem' }}>
                  <div>
                    <span style={{ color: colors.text, fontWeight: 'bold', fontSize: '0.95rem' }}>{event.name}</span>
                    <span style={{ marginLeft: '0.5rem', fontSize: '0.72rem', backgroundColor: event.published ? '#00cc6622' : '#ff444422', color: event.published ? '#00cc66' : '#ff4444', padding: '2px 8px', borderRadius: '20px' }}>
                      {event.published ? 'Publicado' : 'Borrador'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '0.4rem' }}>
                    <button style={styles.publishBtn(event.published)} title={event.published ? 'Despublicar' : 'Publicar'} onClick={() => handleTogglePublish(event)}>
                      {event.published ? <PublicOffIcon style={{ fontSize: 18 }} /> : <PublicIcon style={{ fontSize: 18 }} />}
                    </button>
                    <button style={styles.invBtn} onClick={() => { setInvModal({ show: true, event }); setInvForm({ email: '', quantity: 10 }); setInvSuccess(''); setInvError(''); }}>
                      <ConfirmationNumberIcon style={{ fontSize: 18 }} />
                    </button>
                    <button style={styles.deleteBtn} onClick={() => setDeleteModal({ show: true, id: event.id, name: event.name })}>
                      <DeleteIcon style={{ fontSize: 18 }} />
                    </button>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.4rem' }}>
                  <div>
                    <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>Fecha</p>
                    <p style={{ color: colors.textSecondary, fontSize: '0.85rem' }}>{new Date(event.date).toLocaleDateString('es-ES')}</p>
                  </div>
                  <div>
                    <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>Precio</p>
                    <p style={{ color: colors.accent, fontWeight: 'bold', fontSize: '0.85rem' }}>{event.price}€</p>
                  </div>
                  <div>
                    <p style={{ color: colors.textSecondary, fontSize: '0.72rem', marginBottom: '0.1rem' }}>Entradas</p>
                    <p style={{ color: colors.textSecondary, fontSize: '0.85rem' }}>{event.available_tickets}/{event.total_tickets}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={styles.table}>
            <div style={styles.tableHeader}>
              <span>Evento</span><span>Fecha</span><span>Ubicacion</span>
              <span>Precio</span><span>Gestion</span><span>Entradas</span>
              <span>Categoria</span><span>Estado</span><span>Acciones</span>
            </div>
            {events.map(event => (
              <div key={event.id} style={styles.tableRow}>
                <span style={styles.eventName}>{event.name}</span>
                <span style={styles.cell}>{new Date(event.date).toLocaleDateString('es-ES')}</span>
                <span style={styles.cell}>{event.location}</span>
                <span style={styles.cellAccent}>{event.price}€</span>
                <span style={styles.cellFee}>{parseFloat(event.management_fee).toFixed(2)}€</span>
                <span style={styles.cell}>{event.available_tickets}/{event.total_tickets}</span>
                <span style={styles.cellTag}>{event.category || 'Otros'}</span>
                <span style={{ fontSize: '0.8rem', color: event.published ? '#00cc66' : '#ff4444', fontWeight: 'bold' }}>
                  {event.published ? '● Publicado' : '● Borrador'}
                </span>
                <div style={{ display: 'flex', gap: '0.4rem' }}>
                  <button style={styles.publishBtn(event.published)} title={event.published ? 'Despublicar' : 'Publicar'} onClick={() => handleTogglePublish(event)}>
                    {event.published ? <PublicOffIcon style={{ fontSize: 18 }} /> : <PublicIcon style={{ fontSize: 18 }} />}
                  </button>
                  <button style={styles.invBtn} title="Generar invitaciones" onClick={() => { setInvModal({ show: true, event }); setInvForm({ email: '', quantity: 10 }); setInvSuccess(''); setInvError(''); }}>
                    <ConfirmationNumberIcon style={{ fontSize: 18 }} />
                  </button>
                  <button style={styles.deleteBtn} onClick={() => setDeleteModal({ show: true, id: event.id, name: event.name })}>
                    <DeleteIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Admin;